import React from 'react'

import s from "./styles.pcss";

export default function ErrorOverlay(props) {
  return (
    <div className={s.overlay}>
      <div className={s.content}>
        {props.value || 'An error occurred, please refresh the page.'}
      </div>
    </div>
  );
}